import styled from 'styled-components'

export const IconsRowContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;    
`

export const IconsRowIconWrapper = styled.div`
  position: absolute;
  left: ${(p) => {
    return p.left
  }};
  z-index: ${(p) => {
    return p.zIndex
  }};
`

export const IconsRowsIcon = styled.div`
  height: 24px;
  width: 24px;
  background: ${(p) => {
    return p.backGroundColor
  }};
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  font-size: 10px;
  font-weight: 500;
`

export const IconsRowsUsersNumberWrapper = styled.div`
  color: rgba(32, 32, 32, 0.7);
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  display: flex;
  position: absolute;
  left: 64px;
`

export const IconsRowUsersNumber = styled.div`
  margin-left: 4px;
`
